module.exports = __webpack_public_path__ + "static/illustration-be42318ce17015556f64655dc465f836.svg";